export default "__VITE_ASSET__CCFTnH4r__"